import { createSelector } from 'reselect'
import getRemindersPostSampleSurveySelect from 'modules/post-sample-survey/redux/selectors/get-reminders'

const getReminderPostSampleSurveySelect = createSelector(
  getRemindersPostSampleSurveySelect,
  (reminders) => reminders?.[0]
)

export default getReminderPostSampleSurveySelect
